import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
import Cookies from "js-cookie";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
import zenscroll from "zenscroll";
import { Loader } from "@googlemaps/js-api-loader";
import Player from "@vimeo/player";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
const header = document.querySelector("header");
let overlayInner, overlayCloser;
if (typeof overlay != "undefined" && overlay != null) {
  overlayInner = overlay.querySelector(".inner");
  overlayCloser = overlay.querySelector(".closer");
}

window.addEventListener("load", function () {
  //Dark/Light Mode toggle
  let toggleSwitch = document.querySelector(".switch input");

  if (typeof toggleSwitch != "undefined" && toggleSwitch != null) {
    toggleSwitch.addEventListener("change", () => {
      document.documentElement.classList.toggle(
        "dark-mode",
        toggleSwitch.checked,
      );
      if (toggleSwitch.checked) {
        localStorage.setItem("dark-mode", "enabled");
      } else {
        localStorage.setItem("dark-mode", "disabled");
      }
    });

    // Get saved mode or default to enabled
    const savedMode = localStorage.getItem("dark-mode");
    if (savedMode === "disabled") {
      toggleSwitch.checked = false;
      document.documentElement.classList.remove("dark-mode");
    } else {
      toggleSwitch.checked = true;
      document.documentElement.classList.add("dark-mode");
    }
  }

  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* DEV LOGS */
  /* ***************************************** */
  /*
  console.log(
    "GY - REMINDER: If the overlay is only linking to one page, you need to change $theLink back to production. It's currently set to dev."
  );
  */
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  ScrollSmoother.create({
    smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true, // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  });

  // global animation effects
  ScrollTrigger.batch(".fadeUp", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
    },
  });

  ScrollTrigger.batch(".fadeOn", {
    onEnter: (elements, triggers) => {
      gsap.to(elements, { opacity: 1, stagger: 0.1 });
    },
  });

  setTimeout(function () {
    ScrollTrigger.batch(".fadeUpDelay", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });
  }, 300);

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    // if (
    //   !window.matchMedia("(max-width: 767px) and (orientation: portrait)")
    //     .matches
    // ) {
    arRows(rowsEl);
    var rows = document.querySelectorAll(".ar-rows.work .row");
    rows.forEach(function (row) {
      if (row.children.length === 1) {
        row.classList.add("full_width");
      }
    });
    // }
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  // initialize instant load images
  let instantLoadImages = document.querySelectorAll(".loadmeinstant");
  instantLoadImages.forEach((instantLoadImage) => {
    loadImage(instantLoadImage);
  });

  //initialize lazyload - sitewide for image
  const lazyLoad = new LazyLoad({
    elements_selector: ".loadmeview",
    callback_enter: loadImage,
  });

  //initialize lazyload - autoplay videos
  const lazyLoadAutoVideo = new LazyLoad({
    elements_selector: ".autovideo",
    threshold: 30,
    callback_enter: playAutoVideo,
    callback_exit: pauseAutoVideo,
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  // setup hover grid videos
  let hoverVideos = document.querySelectorAll(".hovervideo");
  hoverVideos.forEach((hoverVideo) => {
    hoverVideo.addEventListener("mouseenter", function () {
      playAutoVideo(hoverVideo);
    });
    hoverVideo.addEventListener("mouseleave", function () {
      pauseAutoVideo(hoverVideo);
    });
  });

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");
  let counterEl = document.querySelector(".counter .current");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
    });

    // change event
    flkty.on("change", function (index) {
      let slideCount = index + 1;
      counterEl.innerHTML = slideCount;
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  // SETUP NAV WORK SUB ANIMATION.  HOVER TRIGGERED ON DESKTOP, CLICK ON MOBILE
  let workSubs = header.querySelectorAll("ul.subs");
  workSubs.forEach((workSub) => {
    let subTrigger = workSub.previousElementSibling;
    let subParent = workSub.parentNode;
    if (innerWidth > 932 && innerHeight > 645) {
      let hoverTimer;
      let intentDelay = 200; // Delay in milliseconds

      subParent.addEventListener("mouseenter", function () {
        hoverTimer = setTimeout(() => {
          // Only execute if mouse is still over element
          if (subParent.matches(":hover")) {
            // loop through all workSub li elements and get the height
            let subHeight = 0;
            let subItems = workSub.querySelectorAll("li");
            subItems.forEach((subItem) => {
              let subItemHeight = subItem.offsetHeight;
              subHeight += subItemHeight;
            });
            // set the height of the workSub to the total height of the li elements
            workSub.style.height = subHeight + "px";
            workSub.classList.add("on");
          }
        }, intentDelay);
      });

      subParent.addEventListener("mouseleave", function () {
        // Clear the timer if mouse leaves before delay
        clearTimeout(hoverTimer);
        let subHeight = 0;
        workSub.style.height = subHeight + "px";
        workSub.classList.remove("on");
      });
    } else if (innerWidth > 932 && innerHeight <= 645) {
      // disable hover and submenu for small height screens
      console.log("click to work");
    } else {
      // mobile click event
      subTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (subParent.classList.contains("on")) {
          subParent.classList.remove("on");
          workSub.style.height = 0;
        } else {
          subParent.classList.add("on");
          let subHeight = 0;
          let subItems = workSub.querySelectorAll("li");
          subItems.forEach((subItem) => {
            let subItemHeight = subItem.offsetHeight;
            subHeight += subItemHeight;
          });
          workSub.style.height = subHeight + "px";
        }
      });
    }
  });

  //INTRO ANIMATION
  let introLogo = document.querySelector(".intro_logo");
  let introGrid = document.querySelector(".homepage .ar-rows.intro");
  if (typeof introLogo != "undefined" && introLogo != null) {
    let paths = introLogo.querySelectorAll("path");
    let a = paths[0];
    let v = paths[1];
    let slash = paths[2];
    let oddRows = introGrid.querySelectorAll(".row:nth-child(odd)");
    let evenRows = introGrid.querySelectorAll(".row:nth-child(even");
    introTL = gsap.timeline({ delay: 0.1 });
    introTL
      .from(introGrid, {
        y: "40%",
        duration: 3,
        ease: "power3.inOut",
      })
      .to(
        introGrid,
        {
          opacity: 1,
          duration: 1.5,
          ease: "power2.in",
        },
        0.5,
      )
      .from(
        oddRows,
        {
          x: "5%",
          duration: 2.5,
          ease: "power3.inOut",
        },
        "<",
      )

      .from(
        evenRows,
        {
          x: "-5%",
          duration: 2.5,
          ease: "power3.inOut",
        },
        "<",
      )

      .to(
        header,
        {
          opacity: 1,
        },
        "<",
      )
      .to(
        introLogo,
        {
          opacity: 1,
          duration: 1.5,
          ease: "power2.inOut",
        },
        ".7",
      )
      .from(
        a,
        {
          x: "75px",
          duration: 1.5,
          ease: "power1.out",
        },
        "1",
      )
      .from(
        v,
        {
          x: "-75px",
          duration: 1.5,
          ease: "power1.out",
        },
        "<",
      )
      .from(
        slash,
        {
          clipPath: "inset( 25% 0 25% 0)",
          duration: 1.5,
          ease: "power1.out",
        },
        "<",
      )
      .from(
        header,
        {
          y: "-100%",
          duration: 0.9,
          ease: "power1.out",
        },
        ".5",
      );

    document.addEventListener("scroll", () => {
      let logoTL = gsap.timeline();
      logoTL.to(introLogo, {
        opacity: 0,
        duration: 0.9,
        ease: "power3.out",
      });
    });

    Cookies.set("sawIntro", "yes", { expires: 7 });
  }

  /* Initialize Google Maps */

  const mapStyles = [
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [
        {
          color: "#e9e9e9",
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 29,
        },
        {
          weight: 0.2,
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 18,
        },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry",
      stylers: [
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "geometry",
      stylers: [
        {
          color: "#f5f5f5",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [
        {
          color: "#dedede",
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          visibility: "on",
        },
        {
          color: "#ffffff",
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          saturation: 36,
        },
        {
          color: "#333333",
        },
        {
          lightness: 40,
        },
      ],
    },
    {
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [
        {
          color: "#f2f2f2",
        },
        {
          lightness: 19,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: "administrative",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#fefefe",
        },
        {
          lightness: 17,
        },
        {
          weight: 1.2,
        },
      ],
    },
  ];

  const initMap = async (elementId, position, title) => {
    const el = document.getElementById(elementId);
    if (typeof el == "undefined" || el == null) return;

    const { Map } = await google.maps.importLibrary("maps");

    const map = new Map(el, {
      center: position,
      zoom: 12,
      disableDefaultUI: true,
      styles: mapStyles,
    });

    new google.maps.Marker({
      position: position,
      map,
      icon: {
        url: "/images/mapPin.svg", // Path to your custom marker image
        scaledSize: new google.maps.Size(40, 40), // Set the size of your marker
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(20, 40), // Center point of the marker (half width, full height)
      },
      title,
    });
  };

  if (document.getElementById("map") || document.getElementById("map2")) {
    const loader = new Loader({
      apiKey: "AIzaSyCpiLkqEwlmFJDEET_V5sAbXCYol3BtlC4",
      version: "weekly",
      // ...additionalOptions,
    });

    loader.load().then(async () => {
      // office location
      await initMap("map", { lat: 34.0733892, lng: -118.3444124 }, "AV Squad");

      // second location
      await initMap("map2", { lat: 51.514719, lng: -0.13599 }, "AV Squad");
    });
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */
  // hover play video
  // let arRows = document.querySelectorAll(".ar-rows");
  // if (typeof arRows != "undefined" && arRows != null) {
  //   let figures = document.querySelectorAll(".cell");
  //   console.log(figures);
  //   figures.forEach((figure) => {
  //     const vidhold = figure.querySelector(".vidhold");

  //     if (vidhold) {
  //       console.log(vidhold);
  //       let video = vidhold.querySelector("video");
  //       console.log(video);
  //     }
  //     figure.addEventListener("mouseenter", () => {
  //       video.play();
  //     });
  //   });
  // }

  function resizeVideoControls(player) {
    let video = player.querySelector("video");
    let controls = player.querySelector(".controls");
    let videoWidth = video.offsetWidth;
    controls.style.width = videoWidth + "px";
    controls.classList.remove("hide");
  }

  // call resizeVideoControls on window resize
  window.addEventListener("resize", function () {
    let videoPlayersEls = document.querySelectorAll(".cell .media video");
    videoPlayersEls.forEach((videoPlayerEl) => {
      let player = videoPlayerEl.closest(".cell .media");
      resizeVideoControls(player);
    });
  });

  //CUSTOM VIDEO CONTROLS
  function videoControls(player) {
    let video = player.querySelector("video");
    let controls = player.querySelector(".controls");
    //let largeBtn = player.querySelector(".largeBtn");
    let playpauseBtn = player.querySelector(".playpause");
    // let muteBtn = player.querySelector(".mute");
    let volumeSlider = player.querySelector("#volume-bar");
    let volumeBg = player.querySelector(".volume .bg");
    let seekSlider = player.querySelector("#seek-bar");
    let seekDot = player.querySelector(".scrubber .square");
    let seekBg = player.querySelector(".scrubber .bg");
    let fullBtn = player.querySelector(".gofull");
    let closeBtn = player.querySelector(".close-icon");
    let timestampEl = player.querySelector(".timestamp");
    let durationEl = player.querySelector(".timestamp .duration");
    let progressEl = player.querySelector(".timestamp .progress");

    // event listeners
    video.addEventListener("canplay", videoCanPlay);
    video.addEventListener("playing", videoPlaying);
    video.addEventListener("pause", videoPaused);
    video.addEventListener("timeupdate", videoTimeUpdate);
    video.addEventListener("ended", videoEnded);
    //largeBtn.addEventListener("click", playPause);
    video.addEventListener("click", playPause);
    playpauseBtn.addEventListener("click", playPause);

    // muteBtn.addEventListener("click", volumeToggle);
    seekSlider.addEventListener("input", videoSeek);
    // volumeSlider.addEventListener("input", volumeChange);
    fullBtn.addEventListener("click", goFullView);
    //closeBtn.addEventListener("click", closeFullView);

    // keyboard events
    body.addEventListener("keydown", (event) => {
      // toggle play / pause of video with spacebar

      // esc key closes lightbox
      if (event.keyCode === 27 && body.classList.contains("full")) {
        event.preventDefault();
        body.classList.remove("full");
      }
    });

    // show / hide controls based on mousemovement over video
    var mousetimeout;
    player.onmousemove = function () {
      clearTimeout(mousetimeout);
      controls.classList.remove("hide");
      mousetimeout = setTimeout(function () {
        // hide video controls if no mouse movement after 2 seconds
        controls.classList.add("hide");
      }, 2000);
    };

    player.onmouseleave = function () {
      controls.classList.add("hide");
    };

    // hide controls after 2 seconds is no user action is taken
    setTimeout(function () {
      controls.classList.add("hide");
    }, 2000);

    // functions
    function playPause() {
      if (!video.paused && !video.ended) {
        video.pause();
      } else {
        video.play();
      }
    }

    function toggleFullScreen() {
      if (
        !document.fullscreenElement &&
        !document.mozFullScreen &&
        !document.webkitIsFullScreen &&
        !document.msFullscreenElement
      ) {
        if (player.requestFullscreen) {
          player.requestFullscreen();
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen();
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen();
        } else if (player.msRequestFullscreen) {
          player.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }

    function videoEnded() {
      player.classList.add("ended");
      player.closest(".cell").classList.remove("full_playing");
    }

    function videoCanPlay() {
      resizeVideoControls(player);
    }

    function videoPlaying() {
      body.classList.add("hide_mark");
      player.classList.add("playing");
      player.classList.remove("ended");
      player.classList.remove("paused");
      timestampEl.classList.add("show");
    }

    function videoPaused() {
      player.classList.remove("playing");
      player.classList.add("paused");
      body.classList.remove("hide_mark");
    }

    function videoTimeUpdate() {
      let rawTime = video.currentTime;
      let minutes = 0;
      let seconds = 0;

      minutes = parseInt(rawTime / 60);
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      seconds = parseInt(rawTime) - minutes * 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      let output = `${minutes}:${seconds}`;
      progressEl.innerHTML = output;

      // Calculate the slider value
      var value = (100 / video.duration) * video.currentTime;

      // transition the timestamp el by animation left value
      timestampEl.style.left = value + "%";

      // Update the slider value and bg value
      seekSlider.value = value;
      seekBg.style.width = value + "%";
    }

    function videoSeek() {
      // Calculate the new time
      var time = video.duration * (seekSlider.value / 100);

      // Update the video time
      video.currentTime = time;
    }

    function volumeToggle() {
      if (video.muted == false) {
        video.muted = true;
        player.classList.add("muted");
      } else {
        video.muted = false;
        player.classList.remove("muted");
      }
    }

    function volumeChange() {
      video.volume = volumeSlider.value;
      volumeBg.style.width = volumeSlider.value * 100 + "%";
    }

    function goFullView() {
      toggleFullScreen();
    }

    function closeFullView() {
      body.classList.remove("full");
    }
  }

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector(".vidhold video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("autoplaying");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector(".vidhold video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      videoEl.play();
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    let src = "https://featured.avsquad.com";

    if (image.classList.contains("local")) {
      src = "";
    }

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = src + "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = src + "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = src + "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = src + "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = src + "/images/pics/1920/" + img;
      } else {
        imgpath = src + "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    // temp check for wordpress content, this needs to be removed when all image sizes are created
    if (image.classList.contains("wordpress")) {
      imgpath = src + "/uploads/" + img;
    }

    if (image.classList.contains("embed")) {
      imgpath = img;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        image.classList.add("img_loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
    body.classList.add("overlay_open");

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        closeOverlay();
      }
    });
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    body.classList.remove("overlay_open");
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  // autoplay logo carousel

  function logoCarouselInit() {
    let carouselParent = logoCarouselEl.closest(".scrolling-logos");
    let tickerSpeed = -0.5;
    let isPaused = false;
    let flktyLogos;

    const update = () => {
      if (isPaused) return;
      carouselParent.style.opacity = 1;
      if (flktyLogos.slides) {
        flktyLogos.x = (flktyLogos.x + tickerSpeed) % flktyLogos.slideableWidth;
        //flktyLogos.x = flktyLogos.x * -1;

        flktyLogos.selectedIndex = flktyLogos.dragEndRestingSelect();
        flktyLogos.updateSelectedSlide();
        flktyLogos.settle(flktyLogos.x);
      }
      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    flktyLogos = new Flickity(logoCarouselEl, {
      // options
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      groupCells: 4,
      selectedAttraction: 0.015,
      friction: 0.25,
    });
    flktyLogos.x = 0;

    update();
  }

  let logoCarouselEl = document.querySelector(".scrolling-logos");
  if (typeof logoCarouselEl != "undefined" && logoCarouselEl != null) {
    logoCarouselInit();
  }

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // check for .CookieDeclaration element and move to end of article if found.
  // Cookiebot's cd.js is loaded async, so the element usually isn't in the DOM
  // yet at load - watch for it instead of assuming it's there.
  let cookieDeclarationScript = document.getElementById("CookieDeclaration");
  if (cookieDeclarationScript) {
    const moveCookieDeclaration = () => {
      let cookieDeclaration = document.querySelector(".CookieDeclaration");
      let article = document.querySelector("article");
      if (cookieDeclaration == null || article == null) {
        return false;
      }
      if (cookieDeclaration.parentNode != article) {
        article.appendChild(cookieDeclaration);
      }
      // hidden via CSS until it's in the right place
      cookieDeclaration.style.opacity = 1;
      return true;
    };

    if (!moveCookieDeclaration()) {
      let cookieDeclarationObserver = new MutationObserver(() => {
        if (moveCookieDeclaration()) {
          cookieDeclarationObserver.disconnect();
        }
      });
      cookieDeclarationObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
      // give up watching if cd.js is blocked or never renders
      setTimeout(() => {
        cookieDeclarationObserver.disconnect();
      }, 10000);
    }
  }

  // custom click event for the cookie preferences
  let cookiePrefBtn = document.getElementById("cookie-preferences-trigger");
  if (cookiePrefBtn) {
    cookiePrefBtn.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("button.CookiebotWidget-logo").click();
    });
  }

  function predictiveSearch(form) {
    let searchField = form.querySelector("input[name='keywords']");
    let searchResults = form.querySelector(".search_results");
    let searchResultsList = searchResults.querySelector("ul");

    // Create debounce function
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // Debounced search function
    const debouncedSearch = debounce((value) => {
      if (value.length > 2) {
        getAjax("/getSearchResults.php?q=" + value, function (data) {
          searchResultsList.innerHTML = data;
          searchResults.classList.add("show_results");
        });
      } else {
        searchResultsList.innerHTML = "";
        searchResults.classList.remove("show_results");
      }
    }, 200); // Wait 300ms after last input before searching

    // Add event listener using debounced function
    searchField.addEventListener("input", function () {
      debouncedSearch(this.value);
    });
  }

  // overlay links
  let overlayLinks = document.querySelectorAll(".openOverlay");
  if (overlayLinks) {
    overlayLinks.forEach((overlayLink) => {
      overlayLink.addEventListener("click", function (e) {
        e.preventDefault();

        if (overlayLink.classList.contains("search")) {
          getAjax("/getSearch.php", function (data) {
            overlayInner.innerHTML = data;

            // predictive search results
            let searchForm = document.getElementById("searchForm");
            predictiveSearch(searchForm);
            searchForm.querySelector("input[name='keywords']").focus();

            openOverlay();
          });
        } else {
          let id = overlayLink.getAttribute("data-id");
          let from = overlayLink.getAttribute("data-from");

          getAjax("/getItem.php?id=" + id + "&from=" + from, function (data) {
            overlayInner.innerHTML = data;
            let overlayContent = overlayInner.querySelector(".cell .media");
            let videoEl = overlayInner.querySelector("video");
            let embedEl = overlayInner.querySelector(".embed_wrap");
            let imageEl = overlayInner.querySelector(".cell img.photo");
            if (typeof videoEl != "undefined" && videoEl != null) {
              if (videoEl.classList.contains("sizeload")) {
                sizeloadVideo(videoEl, "no");
              }
              videoControls(overlayContent);
            } else if (typeof embedEl != "undefined" && embedEl != null) {
              embedEl.style.opacity = 0;
              let videoId = embedEl.getAttribute("data-id");
              let videoType = embedEl.getAttribute("data-type");
              if (videoType === "youtube") {
                // todo youtube player
              } else {
                var playerOptions = {
                  id: videoId,
                  responsive: true,
                };
                var video01Player = new Player(embedEl, playerOptions);

                // Get video metadata to determine aspect ratio
                video01Player.getVideoWidth().then(function (width) {
                  video01Player.getVideoHeight().then(function (height) {
                    const aspectRatio = height / width;

                    // If video is portrait (taller than wide)
                    if (aspectRatio > 1) {
                      // Set parent width to maintain aspect ratio
                      const maxHeight = window.innerHeight * 0.7; // 70% of viewport height
                      const newWidth = maxHeight / aspectRatio;
                      embedEl.style.width = newWidth + "px";
                      embedEl.style.maxWidth = "100%";
                    }

                    video01Player.play();
                    embedEl.style.opacity = 1;
                  });
                });
              }
            } else {
              loadImage(imageEl);
            }
            openOverlay();
          });
        }
      });
    });
  }

  //hamburger menu toggle
  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        (event.preventDefault(), document.body.classList.toggle("menuOn"));
      },
      true,
    );
  }

  if (typeof nav != "undefined" && nav != null) {
    nav.addEventListener("click", function (event) {
      if (document.body.classList.contains("menuOn")) {
        document.body.classList.toggle("menuOn");
      }
    });
  }

  if (typeof overlay != "undefined" && overlay != null) {
    // close overlay
    overlayCloser.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        closeOverlay();
      },
      true,
    );
  }

  //Hover animations for homepage

  if (body.classList.contains("homepage")) {
    if (innerWidth > 932) {
      let homepageGrid = document.querySelector(".homepage .ar-rows");
      let homepageRows = homepageGrid.querySelectorAll(
        ".homepage .ar-rows .row",
      );
      let gridX = gsap.getProperty(homepageGrid, "x");
      gridX = gridX * -1 + 20;
      homepageRows.forEach((row) => {
        row.addEventListener("mousemove", function (e) {
          let mouseX = e.clientX - window.innerWidth / 2;
          if (mouseX >= gridX) {
            mouseX = gridX;
          }
          if (mouseX <= gridX * -1) {
            mouseX = gridX * -1;
          }

          gsap.to(this, { x: mouseX * -1, duration: 1, ease: "linear" });
        });
        row.addEventListener("mouseleave", function () {
          gsap.to(this, { x: 0, duration: 1, ease: "Power3.In" });
        });
      });
    } else {
      // on mobile, how can I make each row auto scroll left and right?
      let homepageGrid = document.querySelector(".homepage .ar-rows");
      let homepageRows = homepageGrid.querySelectorAll(
        ".homepage .ar-rows .row",
      );
      homepageRows.forEach((row, index) => {
        // Determine direction based on row index (even/odd)
        const direction = index % 2 === 0 ? "-=" : "+=";

        // Create infinite side-to-side animation
        gsap.to(row, {
          x: direction + "10%", // Move left/right by 10%
          duration: 10,
          ease: "none",
          repeat: -1, // Infinite repeat
          yoyo: true, // Reverse animation when complete
        });
      });
    }
  }

  // Subfilter disappear when next project comes in
  // let subFilter = document.querySelector(".subfilter");
  // let nextProject = document.querySelector(".next_project");

  // if (typeof nextProject != "undefined" && nextProject != null) {
  //   ScrollTrigger.create({
  //     trigger: nextProject,
  //     start: "top 65%",
  //     end: "top 80%",
  //
  //     onEnter: () => gsap.to(subFilter, { opacity: 0 }),
  //     onLeaveBack: () => gsap.to(subFilter, { opacity: 1 }),
  //   });
  // }

  // Mobile view: inject filter into smoothwrapper
  function insertFilter() {
    let twoCol = document.querySelector(".two_col");
    let contentInner = document.querySelector("#content .inner");
    contentInner.prepend(twoCol);
    //body.style.overflow = "hidden";
  }

  // FOR CAREER PAGE:
  let careerPage = document.querySelector(".careers");
  if (typeof careerPage != "undefined" && careerPage != null) {
    if (window.matchMedia("(max-width: 767px)").matches) {
      insertFilter();
    }
  }

  // FOR PROJECT PAGE:

  let projectPage = document.querySelector(".projectdetail");
  if (typeof projectPage != "undefined" && projectPage != null) {
    // Project detail expand media
    let projectArRows = projectPage.querySelectorAll("section .ar-rows");
    let projectGrids = projectPage.querySelectorAll("section .two_col_grid");
    if (projectArRows.length > 0) {
      projectArRows.forEach((ArRow) => {
        let button = ArRow.nextElementSibling;

        // check that there is actual content in hidden rows
        let hiddenRowsCells = ArRow.querySelectorAll(".hidden .cell");
        let totalCells = ArRow.querySelectorAll(".cell");
        if (hiddenRowsCells.length == 0 || totalCells.length < 3) {
          button.style.display = "none";
        }

        if (typeof button != "undefined" && button != null) {
          let hiddenRows = ArRow.querySelectorAll(".hidden");
          button.addEventListener("click", () => {
            hiddenRows.forEach((hidden) => {
              hidden.classList.remove("hidden");
            });
            button.classList.add("hidden");

            // refresh scrollTrigger after expanding rows
            setTimeout(() => ScrollTrigger.refresh(), 100);
          });
        }
      });
    }
    if (projectGrids.length > 0) {
      projectGrids.forEach((projectGrid) => {
        let button = projectGrid.nextElementSibling;
        if (typeof button != "undefined" && button != null) {
          let hiddenRows = projectGrid.querySelectorAll(".hidden");
          button.addEventListener("click", () => {
            hiddenRows.forEach((hidden) => {
              hidden.classList.remove("hidden");
            });
            button.classList.add("hidden");

            // refresh scrollTrigger after expanding rows
            setTimeout(() => ScrollTrigger.refresh(), 100);
          });
        }
      });
    }

    // Scroll animation for Project Detail
    let textColTl;
    let content = document.querySelector("#smooth-content");
    let slash_background = projectPage.querySelector(".background svg");

    function initProjectDetailAnimation() {
      // Clear previous timeline if it exists
      if (textColTl) {
        textColTl.kill();
      }

      // Create a new timeline
      textColTl = gsap.timeline();
      textColTl.to(".projectdetail .two_col", {
        opacity: 0,
        scrollTrigger: {
          trigger: ".projectdetail .next_project",
          start: "top center",
          end: "top 20%",
          markers: false,
          scrub: 1,
        },
      });
    }

    if (
      typeof slash_background != "undefined" &&
      slash_background != null &&
      innerWidth > 932
    ) {
      initProjectDetailAnimation();

      let backgroundTL = gsap.timeline();
      backgroundTL.to(slash_background, {
        x: "5%",
        scrollTrigger: {
          trigger: content,
          start: "top top",
          end: "bottom bottom",
          markers: false,
          scrub: 0.1,
        },
      });
    }

    if (
      window.matchMedia("(max-width: 767px) and (orientation: portrait)")
        .matches
    ) {
      insertFilter();
    }

    window.addEventListener("resize", function () {
      if (
        window.matchMedia("(max-width: 767px) and (orientation: portrait)")
          .matches
      ) {
        insertFilter();
      }
    });
  }

  // campaign detail page - check for hash value in URL
  let campaignPage = document.querySelector(".projectdetail");
  if (typeof campaignPage != "undefined" && campaignPage != null) {
    let hash = window.location.hash;
    if (hash) {
      let link = document.querySelector(`a[href="${hash}"]`);
      if (link) {
        link.click();
        let parent = link.closest("li");
        if (typeof parent != "undefined" && parent != null) {
          // remove focus class from all items
          let filterItems = document.querySelectorAll(".subfilter li");
          filterItems.forEach((filterItem) => {
            filterItem.classList.remove("focus");
          });
          parent.classList.add("focus");
        }
      }
    }

    // Set up Intersection Observer for section_wrap elements
    const sectionWraps = document.querySelectorAll(".section_wrap");

    // Create an observer instance
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const sectionId = entry.target.getAttribute("id");
          if (sectionId) {
            // Find the matching filter link with this href
            const matchingLink = document.querySelector(
              `.subfilter a[href="#${sectionId}"]`,
            );
            if (matchingLink) {
              const parent = matchingLink.closest("li");

              // If section enters viewport, add focus class
              if (entry.isIntersecting) {
                // Remove focus class from all items
                const filterItems = document.querySelectorAll(".subfilter li");
                filterItems.forEach((filterItem) => {
                  filterItem.classList.remove("focus");
                });

                // Add focus class to the parent li of the matching link
                if (parent) {
                  parent.classList.add("focus");
                }
              }
            }
          }
        });
      },
      {
        // Root options - using viewport as root
        rootMargin: "-10% 0px -10% 0px", // Trigger when the element is 10% into the viewport from either top or bottom
        threshold: 0.1, // Trigger when at least 10% of the element is visible
      },
    );

    // Observe all section_wrap elements
    sectionWraps.forEach((section) => {
      observer.observe(section);
    });
  }

  // subfilter clicks
  let subFilterLinks = document.querySelectorAll(".subfilter a");
  subFilterLinks.forEach((subFilterLink) => {
    subFilterLink.addEventListener("click", function () {
      // remove focus class from all items
      let filterItems = document.querySelectorAll(".subfilter li");
      filterItems.forEach((filterItem) => {
        filterItem.classList.remove("focus");
      });
      // apply focus class to selected item
      let parent = subFilterLink.closest("li");
      parent.classList.add("focus");
    });
  });

  // mobile subfilter

  let mobileSubfilter = document.querySelector(".subfilter.mobile");
  let content = document.querySelector(".ar-rows");
  let filterTL = gsap.timeline();
  if (typeof mobileSubfilter != "undefined" && mobileSubfilter != null) {
    gsap.to(mobileSubfilter, {
      opacity: 1,
      scrollTrigger: {
        trigger: document.querySelector("article.inner"),
        start: "top top",
        end: "bottom bottom",
        markers: false,
        toggleActions: "play reverse play reverse",
      },
    });

    /*
    filterTL.to(mobileSubfilter, {
      opacity: 1,
      scrollTrigger: {
        trigger: content,
        start: "top top",
        end: "bottom bottom",
        markers: false,
        scrub: 1,
      },
    });

    gsap.to(mobileSubfilter, {
      opacity: 0,
      scrollTrigger: {
        trigger: document.querySelector("article.inner"),
        start: "bottom bottom",
      },
    });
    */
  }

  /*
  // Filter override
  let filterLinks = document.querySelectorAll(".filter li");
  if (filterLinks.length > 0) {
    if (filterLinks[2].classList.contains("pageOn")) {
      filterLinks[0].classList.remove("pageOn");
    }
  }
    */

  // mouseenter for Archive Table
  let archiveTableRows = document.querySelectorAll(".archive_table tbody tr");
  archiveTableRows.forEach((row) => {
    let rowLink = row.querySelector("a");

    rowLink.addEventListener("mouseenter", () => {
      let img = row.querySelector("img");
      if (!img.classList.contains("img_loaded")) {
        loadImage(img);
      }
      row.classList.add("active");
      img.style.opacity = 1;
    });
    rowLink.addEventListener("mouseleave", () => {
      let img = row.querySelector("img");
      img.style.opacity = 0;
      row.classList.remove("active");
    });
  });

  // Sorting table for Archive
  let archiveTable = document.querySelector(".archive_table");
  if (typeof archiveTable != "undefined" && archiveTable != null) {
    const headers = archiveTable.querySelectorAll("thead th");
    headers.forEach((header) => {
      header.addEventListener("click", () => {
        const table = header.closest("table");
        const tbody = table.querySelector("tbody");
        const rows = Array.from(tbody.querySelectorAll("tr"));
        const column = header.dataset.column;
        const order = header.dataset.order === "asc" ? "desc" : "asc";

        headers.forEach((header) => header.classList.remove("asc", "desc"));
        header.dataset.order = order;
        header.classList.add(order);

        const columnIndex = Array.from(header.parentNode.children).indexOf(
          header,
        );

        rows.sort((a, b) => {
          const aCell = a.children[columnIndex];
          const bCell = b.children[columnIndex];

          if (column === "newest") {
            // Use the machine-readable timestamps for sorting
            const aTimestamp = aCell.dataset.timestamp
              ? new Date(aCell.dataset.timestamp).getTime()
              : 0;
            const bTimestamp = bCell.dataset.timestamp
              ? new Date(bCell.dataset.timestamp).getTime()
              : 0;
            return order === "asc"
              ? aTimestamp - bTimestamp
              : bTimestamp - aTimestamp;
          }

          const aText = aCell.textContent;
          const bText = bCell.textContent;

          if (aText < bText) {
            return order === "asc" ? -1 : 1;
          }
          if (aText > bText) {
            return order === "asc" ? 1 : -1;
          }
          return 0;
        });

        rows.forEach((row) => tbody.appendChild(row));
      });
    });
  }

  //Cycle through list items, take control on hover (only desktop)
  let twoColList = document.querySelector(".two_col_list");
  if (typeof twoColList != "undefined" && twoColList != null) {
    let imgWraps = twoColList.querySelectorAll(".img_wrap");
    if (
      window.matchMedia("(max-width: 767px) and (orientation: portrait)")
        .matches
    ) {
      let listItems = twoColList.querySelectorAll("ul li");

      // on page load, get the height of the first listItems
      let detailsH =
        listItems[0].querySelector(".details .contents").clientHeight;
      listItems[0].querySelector(".details").style.height = detailsH + "px";

      listItems.forEach((item) => {
        // handle click event
        item.addEventListener("click", (e) => {
          let itemCount = item.getAttribute("data-count");
          // get height of item details content
          let detailsH = item.querySelector(".details .contents").clientHeight;
          imgWraps.forEach((imgWrap) => {
            imgWrap.classList.remove("active");
          });
          listItems.forEach((listItem) => {
            listItem.classList.remove("focus");
            listItem.querySelector(".details").style.height = 0;
          });
          item.classList.add("focus");
          item.querySelector(".details").style.height = detailsH + "px";
          imgWraps[itemCount].classList.add("active");
        });
      });
      return;
    } else {
      let listItems = document.querySelectorAll(".two_col_list ul li");

      let currentIndex = 0;
      function cycleFocus() {
        listItems.forEach((listItem, index) => {
          listItem.classList.remove("focus");
          if (index === currentIndex) {
            listItem.classList.add("focus");
          }
        });
        currentIndex = (currentIndex + 1) % listItems.length;
      }

      let cycleInterval = setInterval(cycleFocus, 3000);

      listItems.forEach((listItem) => {
        listItem.addEventListener("mouseover", function () {
          clearInterval(cycleInterval);
          let itemCount = listItem.getAttribute("data-count");
          imgWraps.forEach((imgWrap) => {
            imgWrap.classList.remove("active");
          });
          listItems.forEach((listItem) => {
            listItem.classList.remove("focus");
          });
          listItem.classList.add("focus");
          imgWraps[itemCount].classList.add("active");
        });
      });

      //cycleFocus(); // Initial call to set the first focus
    }
  }
});
